// EtiquetasXL config logosMarcas - S48.2a.
// Mapa local marca -> archivo SVG. Si una marca no tiene entrada en este
// mapa, autolayout/logos.js cae a fallback de TAG DE TEXTO.
// Las SVGs propiamente dichas se entregaran como assets en sprints
// posteriores; por ahora el mapa solo declara las rutas.

export const logosMarcas = {
  "MAZDA": "mazda.svg",
  "SUZUKI": "suzuki.svg",
  "MITSUBISHI": "mitsubishi.svg",
  "DODGE": "dodge.svg",
  "TOYOTA": "toyota.svg",
  "NISSAN": "nissan.svg",
  "RENAULT": "renault.svg",
  "CHEVROLET": "chevrolet.svg",
  "KIA": "kia.svg",
  "HYUNDAI": "hyundai.svg"
};
